/**
 * FilledLineEnding - Renders arrow or T-shape as filled shapes (no strokes).
 *
 * Uses filled polygons with semicircular caps instead of stroked lines,
 * eliminating overlap artifacts at the route/ending junction.
 */

import type { Coordinate } from '@/types'
import { buildFilledArrow, buildFilledTShape } from '@/utils/SvgPath.utils'

type FilledLineEndingProps = {
	lineEnd: 'arrow' | 'tShape'
	point: Coordinate
	angle: number
	strokeWidth: number
	color: string
}

export function FilledLineEnding({ lineEnd, point, angle, strokeWidth, color }: FilledLineEndingProps) {
	const shapes = lineEnd === 'arrow'
		? buildFilledArrow(point, angle, strokeWidth)
		: buildFilledTShape(point, angle, strokeWidth)

	return (
		<>
			{shapes.map((d, i) => (
				<path key={i} d={d} fill={color} />
			))}
		</>
	)
}
